import { VyStack } from '@vy/ui-design-system';
import { useChargeContext } from '../../charge-context';
import { PaymentSection, PricingSection, UpgradeOptionsSection } from '../sections';

export function RefundVariant() {
  const { isInvoice } = useChargeContext();
  return (
    <VyStack sx={{ gap: 2.5 }}>
      <PricingSection showErpSelectors={false} showAnrok={false} />
      {!isInvoice && (
        <PaymentSection showPaymentTerm={false} />
      )}
      <UpgradeOptionsSection />
    </VyStack>
  );
}
